import React from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import Countdown, { zeroPad } from 'react-countdown-now';

function CampaignCountdown({ campaign }) {
  if (dayjs(campaign.expired).isAfter(dayjs())) {
    // eslint-disable-next-line react/prop-types
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
      if (completed) {
        return '';
      }
      return (
        <span>
          <span>
            {days}
            d
          </span>
          <span>&nbsp;&middot;&nbsp;</span>
          <span>
            {zeroPad(hours)}
            :
            {zeroPad(minutes)}
            :
            {zeroPad(seconds)}
          </span>
        </span>
      );
    };
    return <Countdown date={campaign.expired} renderer={renderer} />;
  }
  return '';
}

CampaignCountdown.propTypes = {
  campaign: PropTypes.object,
};

CampaignCountdown.defaultProps = {
  campaign: {},
};

export default CampaignCountdown;
